import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';
import kickoff from '../../photos/aboutus/kickoff.jpeg';
import first from '../../photos/aboutus/first.png';
import image2 from '../../photos/image2.jpg';
import frc from '../../photos/image8.jpg';

const achievements = [
  { value: '4', label: 'FIRST Impact Awards' },
  { value: '2', label: 'FIRST Impact Finalist Awards' },
  { value: '1', label: 'Woodie Flowers Finalist Award' },
  { value: '10', label: 'Blue Banners', tone: 'blue-banner' },
];

const journeyHighlights = [
  'Authored robotics curricula adopted by T\u00fcrkiye\u2019s Ministry of National Education.',
  'Secured $289,110 in scholarships for students across the FIRST community.',
  'Sustained three months of post-earthquake STEAM support, reaching 640 children across 34 container cities.',
  'Started and mentored FIRST teams internationally while training 96 FLL mentors.',
];

const missionPoints = [
  'Expand FIRST and STEM+A education throughout T\u00fcrkiye',
  'Foster innovation and practical application of theoretical knowledge',
  'Create opportunities for youth to bring their original ideas to life',
  'Promote science and engineering as catalysts for positive change',
];

const firstValues = [
  'Gracious Professionalism',
  'Teamwork and Collaboration',
  'Innovation and Problem-solving',
  'Equity, Diversity, and Inclusion',
];

const competitionDetails = [
  'New game revealed annually at global kick-off',
  '6-week build season',
  "Multiple award categories including Chairman's Award",
  'Focus on both technical and non-technical achievements',
];

function AboutUs() {
  return (
    <article
      className="about-us"
      itemScope
      itemType="https://schema.org/Organization"
    >
      <meta itemProp="name" content="INTEGRA 3646" />
      <meta itemProp="foundingDate" content="2011" />
      <meta itemProp="location" content="Istanbul, Turkey" />

      <header className="about-hero fade-in">
        <div className="about-hero__content">
          <h1 itemProp="description">About INTEGRA 3646</h1>
          <p className="about-hero__tagline" itemProp="slogan">
            Pioneering STEM+A Education and FIRST in T&uuml;rkiye since 2011
          </p>
        </div>
      </header>

      <section className="about-section about-journey fade-in" aria-labelledby="about-journey-title">
        <div className="about-section__layout about-journey__layout">
          <div className="about-section__copy about-journey__copy">
            <h2 id="about-journey-title">Our Journey</h2>
            <div itemProp="description">
              <p>
                Founded in 2011 at Bah&ccedil;e&#351;ehir Science and Technology High School in Istanbul,
                Team 3646 Bah&ccedil;e&#351;ehir INTEGRA has grown from a small group of five students
                to a diverse team of 48 members, including 17 female students.
              </p>
              <p>
                As one of T&uuml;rkiye&apos;s first FRC teams, we&apos;re proud to be the first Turkish team
                to reach the Einstein Field in Houston. That journey now includes:
              </p>
            </div>
            <ul className="about-journey__highlights">
              {journeyHighlights.map((highlight) => (
                <li key={highlight}>{highlight}</li>
              ))}
            </ul>
          </div>
          <figure className="about-section__image about-journey__image">
            <img src={kickoff} alt="INTEGRA 3646 team members gathered at kickoff" />
          </figure>
        </div>
      </section>

      <section className="about-section about-mission fade-in" aria-labelledby="about-mission-title">
        <h2 id="about-mission-title">Our Mission</h2>
        <div className="about-mission__body">
          <figure className="about-section__image about-mission__image">
            <img src={image2} alt="INTEGRA students collaborating around robotics work" />
          </figure>
          <ol className="about-mission__list">
            {missionPoints.map((point) => (
              <li key={point}>
                <span>{point}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="about-section about-program fade-in" aria-labelledby="about-program-title">
        <div className="about-program__header">
          <h2 id="about-program-title">The Program</h2>
        </div>
        <div className="about-program__grid">
          <section className="about-program__topic" aria-labelledby="about-first-title">
            <div className="about-program__copy">
              <h3 id="about-first-title">What is FIRST?</h3>
              <p>
                FIRST (For Inspiration and Recognition of Science and Technology) is a global
                nonprofit founded by Dean Kamen in 1989. It provides inclusive, team-based
                robotics programs for young people aged 4-18.
              </p>
              <div className="about-program__details">
                <h4>Core Values</h4>
                <ul>
                  {firstValues.map((value) => (
                    <li key={value}>{value}</li>
                  ))}
                </ul>
              </div>
            </div>
            <figure className="about-program__image about-program__image--logo">
              <img src={first} alt="FIRST program logo" />
            </figure>
          </section>

          <section className="about-program__topic about-program__topic--frc" aria-labelledby="about-frc-title">
            <div className="about-program__copy">
              <h3 id="about-frc-title">FIRST Robotics Competition (FRC)</h3>
              <p>
                FRC is an international high school robotics competition where teams design,
                build, and program industrial-sized robots to compete in annual challenges.
              </p>
              <div className="about-program__details">
                <h4>Competition Structure</h4>
                <ul>
                  {competitionDetails.map((detail) => (
                    <li key={detail}>{detail}</li>
                  ))}
                </ul>
              </div>
            </div>
            <figure className="about-program__image">
              <img src={frc} alt="INTEGRA robot competing at a FIRST Robotics Competition event" />
            </figure>
          </section>
        </div>
      </section>

      <section className="about-section about-record fade-in" aria-labelledby="about-record-title">
        <div className="about-record__header">
          <h2 id="about-record-title">Achievement Record</h2>
        </div>
        <ul className="about-record__list" itemProp="award">
          {achievements.map((achievement) => (
            <li
              className={`about-record__item${
                achievement.tone === 'blue-banner'
                  ? ' about-record__item--blue-banner'
                  : ''
              }`}
              key={achievement.label}
            >
              <span className="about-record__value">{achievement.value}</span>
              <span className="about-record__label">{achievement.label}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="about-section about-next fade-in" aria-labelledby="about-next-title">
        <div className="about-next__content">
          <p className="about-eyebrow">Continue exploring</p>
          <h2 id="about-next-title">See what the team builds and earns.</h2>
          <div className="about-next__actions">
            <Link className="about-button about-button--primary" to="/projects">
              Explore Our Projects
            </Link>
            <Link className="about-button about-button--secondary" to="/awards">
              View Our Awards
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
}

export default AboutUs;
